import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, TextArea, SubmitBtn } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import { decodeData } from '../../Constants/constants';
class Department extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            verification_agency_id: 0,
            verification_agency_name: '',
            login_id: '',
            login_password: '',
            rows: [],
            errors: {},
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            decodedData: [],

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
        })
    }
     componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
        }
    handleInputChange = (e) => {
        const { name, value } = e.target;


        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };
    GetInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetVerificationAgencyInfo?verification_agency_id=${this.state.verification_agency_id}`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                this.setState(
                    {
                        verification_agency_name: data[0].verification_agency_name,
                        login_id: data[0].login_id,
                        login_password: data[0].login_password,
                    }
                )
            }
        });
    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetVerificationAgencies`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {

            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {

            verification_agency_name: this.state.verification_agency_name,
            login_id: this.state.login_id,
            login_password: this.state.login_password
        }
        if (this.state.verification_agency_id !== 0) {
            formData.verification_agency_id = this.state.verification_agency_id;
        }

        axios.post(`${apiURL}Masters/CreateVerificationAgency`, formData, { headers }).then((response) => {

            const { success } = response.data;
            if (success === true) {
                this.resetForm();

                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                })
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    timer: 2000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
            } else {
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    timer: 2000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                })
            }

        })
    };
    resetForm = () => {
        this.setState({
            verification_agency_id: 0,
            verification_agency_name: '',
            login_id: '',
            login_password: '',
        })

    }
    validateForm = () => {
        const errors = {};

        if (!this.state.verification_agency_name) {
            errors.verification_agency_name = 'Agency name is required';
        }
        if (!this.state.login_id) {
            errors.login_id = 'Agency login id is required';
        }
        if (!this.state.login_password) {
            errors.login_password = 'Agency login password id is required';
        }

        return errors;
    };

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    verification_agency_id: id
                };
                axios
                    .post(`${apiURL}Masters/DeleteVerificationAgency`, formData, { headers })
                    .then((response) => {

                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {

        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }
    render() {
        const { errors } = this.state;
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Agency Master`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-5">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Agency Master</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form onSubmit={this.handleSubmit} className="row">
                                                    <div className="col-md-12">
                                                        <label htmlFor="verification_agency_name" className="form-label">Agency Name</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.verification_agency_name ? 'is-invalid' : ''}`}
                                                            id="verification_agency_name"
                                                            name="verification_agency_name"
                                                            value={this.state.verification_agency_name}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Agency Name"
                                                        />
                                                        {errors.verification_agency_name && <div className="text-danger">{errors.verification_agency_name}</div>}
                                                    </div>
                                                    {/* <div className="col-md-12 mt-3">
                                                        <TextBox type='number' id='' name='' label='Agency Contact Number' hint='Enter Agency Contact Number' change={this.handleInputChange} />
                                                    </div> */}
                                                    {/* <div className="col-md-12 mt-3">
                                                        <TextBox type='email' id='' name='' label='Agency Email Address' hint='Enter Agency Email Address' change={this.handleInputChange} />
                                                    </div> */}
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="login_id" className="form-label">Agency Login id</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.login_id ? 'is-invalid' : ''}`}
                                                            id="login_id"
                                                            name="login_id"
                                                            value={this.state.login_id}
                                                            placeholder="Enter Agency Login id"
                                                        />
                                                        {errors.login_id && <div className="text-danger">{errors.login_id}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="login_password" className="form-label">Agency Password</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.login_password ? 'is-invalid' : ''}`}
                                                            id="login_password"
                                                            name="login_password"
                                                            value={this.state.login_password}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Agency Password"
                                                        />
                                                        {errors.login_password && <div className="text-danger">{errors.login_password}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-5">
                                                        {
                                                            this.state.verification_agency_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />

                                                        }

                                                        {
                                                            this.state.verification_agency_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />{" "}New</button> : <div></div>

                                                        }
                                                    </div>
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className='card'>
                                    <div className="col-md-12">
                                        <table className={`table table-bordered table-hover`}>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th width={200}>Agency Names</th>
                                                    <th width={200}>Agency Number</th>
                                                    <th width={200}>Agency Email</th>
                                                    <th width={200}>Agency Login Id</th>
                                                    <th width={200}>Agency Password</th>

                                                    <th width={120}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.rows.map((row) => {
                                                        return <tr key={row.verification_agency_id}>
                                                            <td>{row.verification_agency_name}</td>
                                                            <td>{row.verification_agency_name}</td>
                                                            <td>{row.verification_agency_name}</td>
                                                            <td>{row.login_id}</td>
                                                            <td>{row.login_password}</td>

                                                            <td className='d-flex justify-content-around'>
                                                                <button type='button' onClick={() => this.setState({ verification_agency_id: row.verification_agency_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>
                                                                <button onClick={() => this.handleDelete(row.verification_agency_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>
                                                            </td>
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                            <tfoot className='table-light'>
                                                <tr>
                                                    <th colSpan={6} >
                                                        <div className="d-flex justify-content-between" >
                                                            <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {
                                                                    <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                }
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                    {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                        <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(Department);



